export default `
  query GetProductsBlocks($identifiers: [String!]!) {
    productsBlocks(identifiers: $identifiers) {
      identifier
      title
      html
      products {
        uid
        sku
        name
        made_in_canada
        att_quick_ship
        order_time_frame
        b_collection_name
        new
        best_seller
        further_reduced
        stock_status
        only_x_left_in_stock
        rating_summary
        thumbnail {
          url
          position
          disabled
          label
        }
        url_key
        url_rewrites {
          url
        }
        price_range {
          maximum_price {
            final_price {
              currency
              value
            }
            regular_price {
              currency
              value
            }
          }
          minimum_price {
            final_price {
              currency
              value
            }
            regular_price {
              currency
              value
            }
          }
        }
        categories {
          uid
          name
          url_suffix
          url_path
          breadcrumbs {
            category_name,
            category_url_path
          }
        }
        review_count
        reviews {
          items {
            average_rating
            ratings_breakdown {
              name
              value
            }
          }
        }
        ... on ConfigurableProduct {
          configurable_options {
            attribute_code
            attribute_uid
            label
            position
            uid
            use_default
            values {
              label
              swatch_data {
                value
              }
              uid
              products
            }
            product_id
          }
        }
        ... on GroupedProduct {
          items {
            product {
              sku
            }
          }
        }
      }
    }
  }
`;
